import React, { useState, useEffect } from 'react';
import {
  Container,
  Tabs,
  Tab,
  Paper
} from '@mui/material';
import AccountingJournalPage from './AccountingJournalPage';
import AccountingSettingsPage from './AccountingSettingsPage';
import AccountingPurchaseInvoicesPage from './AccountingPurchaseInvoicesPage';
import AccountingSuppliersPage from './AccountingSuppliersPage';
import { useAuth } from '../contexts/AuthContext';
import { canViewAccountingMovements } from '../utils/roles';

const TAB_MOVEMENTS = 'movements';
const TAB_INVOICES = 'invoices';
const TAB_SUPPLIERS = 'suppliers';
const TAB_SETTINGS = 'settings';

const Accounting = () => {
  const { user } = useAuth();
  const canViewMovements = canViewAccountingMovements(user);
  const [tabValue, setTabValue] = useState(canViewMovements ? TAB_MOVEMENTS : TAB_INVOICES);

  useEffect(() => {
    if (!canViewMovements && tabValue === TAB_MOVEMENTS) {
      setTabValue(TAB_INVOICES);
    }
  }, [canViewMovements, tabValue]);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
      <Paper sx={{ mb: 2 }}>
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          indicatorColor="primary"
          textColor="primary"
          variant="fullWidth"
        >
          {canViewMovements && <Tab value={TAB_MOVEMENTS} label="Movimenti" />}
          <Tab value={TAB_INVOICES} label="Fatturazione passiva" />
          <Tab value={TAB_SUPPLIERS} label="Rubrica fornitori" />
          <Tab value={TAB_SETTINGS} label="Impostazioni" />
        </Tabs>
      </Paper>

      {canViewMovements && tabValue === TAB_MOVEMENTS && (
        <AccountingJournalPage />
      )}

      {tabValue === TAB_INVOICES && (
        <AccountingPurchaseInvoicesPage />
      )}

      {tabValue === TAB_SUPPLIERS && (
        <AccountingSuppliersPage />
      )}

      {tabValue === TAB_SETTINGS && (
        <AccountingSettingsPage />
      )}
    </Container>
  );
};

export default Accounting;
